import {BaseComponentProcessor} from "../../utils/processor/BaseComponentProcessor";

/**
 * Code processor
 */
export class HasInAppPurchaseProcessor extends BaseComponentProcessor {

    /**
     * Process incoming event
     * @param event
     * @param data
     */
    // eslint-disable-next-line no-unused-vars
    async processEvent(event, data) {
        // Get products list
        const products = this.getProductsList();

        const targetPlatform = this.context.renderer.a2u.source.modules[this.context.renderer.a2u.getModuleId()]?.type === 'web' ? 'web' : 'mobile';

        // Debug list of goods for web environment
        if(this.context.renderer.a2u.getPlatform() === "web" && targetPlatform !== 'web') {
            return this.debugResponse({yes: {}, no: {}}, `User bought: ${products} ?`)
        }

        // Get ad instance
        const iapManager = this.context.renderer.a2u.getDevice()?.getPluginInstance?.("IAPManager");

        try {
            // Check if test mode is enabled
            if (iapManager.isTestModeEnabled()) {
                return this.processOutgoingLinks(this.context, this.block.id, undefined, "yes");
            }

            // Get store products
            const storeProducts = Object.keys(await iapManager.getProductList() || {});

            // Update store products if not found
            if (!storeProducts?.length) {
                await iapManager.update();
            }

            let result;

            // Check if user has subscription
            if(products === '*') {
                result = await iapManager?.isSubscribed();
            } else {
                // Check if user has products
                result = await iapManager?.isOwned(products?.split(","));
            }

            this.processOutgoingLinks(this.context, this.block.id, undefined, result ? "yes" : "no");
        } catch (e) {
            console.error("Error check subscription", e);

            // Log error
            this.logError(e);

            this.processOutgoingLinks(this.context, this.block.id, e?.code, "error");
        }
    }

    /**
     * Retrieves the list of products based on the selected groups and fallback value.
     *
     * @returns {string} The list of product IDs or the fallback value if no products are found.
     */
    getProductsList() {
        // Get the fallback value
        const fallbackValue = this.context.interpretString(this.block?.properties?.products)?.trim();

        // Get the selected groups
        const selectedGroups = this.block?.properties?.groups;

        // Return the fallback value if no groups are selected
        if (!selectedGroups?.length) {
            return fallbackValue;
        }

        // Get the list of products
        const products = this.context?.renderer?.a2u?.source?.iap?.products || [];

        // Return the fallback value if no products are found
        if (!products.length) {
            return fallbackValue;
        }

        // Filter the products based on the selected groups and return the product IDs
        return products.filter((p) => selectedGroups.includes(p.group)).map((p) => p.productId).join(',');
    }
}
